<template>
  <a class="player-btn-wrapper">
    <svg :width="width" :height="height" :class="{'disabled': disabled}" viewBox="0 0 80 80" class="player-btn static">
      <circle class="circle-base" cx="40" cy="40" r="38" />
      <circle ref="circleTrack" class="circle-track" cx="40" cy="40" r="38" />
      <path class="play-btn" d="M31.93 52.033V27.967a3.059 3.059 0 0 1 4.844-2.482l16.723 12.032a3.059 3.059 0 0 1 0 4.966L36.774 54.515a3.059 3.059 0 0 1-4.845-2.482z" />
    </svg>
  </a>
</template>
<script>
export default {
  name: 'PlayerStaticPlayBtn',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 80
    },
    height: {
      type: [Number, String],
      default: 80
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    btnOnClick() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.player-btn {
  border-radius: 50%;
  background-color: #ffffff;
  cursor: pointer;
  &-wrapper {
    display: inline-block;
    text-decoration: none;
  }
  .circle-base {
    fill: none;
    stroke: $grey-ec;
    stroke-width: 3px;
  }
  .circle-track {
    transform-origin: 50% 50%;
    transform: rotate(-90deg);
    stroke: $grey-ec;
    stroke-width: 3px;
    fill: none;
    stroke-dasharray: 0, 0;
    stroke-linecap: square; // square, round;
  }
  .play-btn {
    fill: $grey-50;
    transition: fill 0.2s ease;
  }
  .play-btn:active {
    fill: red;
    transition: fill 0.2s ease;
  }
  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    .play-btn,
    .pause-btn {
      fill: $grey-ec;
    }
    &.static:hover {
      .circle-track.playing {
        stroke: $grey-ec;
      }
      .play-btn,
      .pause-btn {
        fill: $grey-ec;
      }
    }
  }
}
// hover status
@media (hover: hover) {
  .player-btn {
    &.static:hover {
      .play-btn {
        fill: $grey-9b;
      }
    }
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
